module.exports = __webpack_public_path__ + "img/heat-cost-allocator-md.c5f78abb.svg";